module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/waste-glass-bottle2/font/notokr-medium.woff
// module id = kWYn
// module chunks = 0